import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";

import React from "react";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/portal_utilities';
const PROFILE_ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/save_profile';
const SETTINGS_ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/save_settings';

class PortalAccountSettings extends React.Component {
    constructor(){
        super();
        this.state = {
            isloggedin: false,
            rstatus: '',
            rmessage: '',
            rdata: [],
            palertColor: '',
            rpstatus: '',
            rpmessage: '',
            rpdata: [],
            salertColor: '',
            rsstatus: '',
            rsmessage: '',
            rsdata: []
        }

        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
        });
    }

    async getUserData(){
        var data = {action: 'get_userdata'};

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            rdata: rdata.userdata
        });

        if (rstatus === true){
            var genderSelect = document.getElementsByName('gender')[0];
            for (var i=0; i<genderSelect.options.length; i++){
                genderSelect.options[i].selected = rdata.userdata.gender === genderSelect.options[i].value; 
            }
        }
    }


    handleProfileSubmit = async (e) => {
        e.preventDefault();

        let data = Object.fromEntries(new FormData(e.target));

        const {rstatus, rmessage, rdata } = await callAPI(PROFILE_ENDPOINT, data); 
        this.setState({
            rpstatus: rstatus,
            rpmessage: rmessage,
            rpdata: rdata
        });
        
        if (rstatus === true){ 
            this.setState({palertColor: 'green'});
            window.location = '/portal/account/settings';
        } 
        else if (rstatus === false) { 
            this.setState({palertColor: 'red'}); 
        }
    }

    handleSettingsSubmit = async (e) => {
        e.preventDefault();

        let data = Object.fromEntries(new FormData(e.target));

        const {rstatus, rmessage, rdata } = await callAPI(SETTINGS_ENDPOINT, data); 
        this.setState({
            rsstatus: rstatus,
            rsmessage: rmessage,
            rsdata: rdata
        });
        
        if (rstatus === true){ 
            this.setState({salertColor: 'green'}); 
        } 
        else if (rstatus === false) { 
            this.setState({salertColor: 'red'}); 
        }
    }

    componentDidMount(){
        this.getUserData(); 
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />
                        
                    <div className="content">
                            
                        <PortalTopMenu page_name="Account Settings" />

                        <div className="intro-y flex items-center mt-8">
                            <h2 className="text-lg font-medium mr-auto">
                                Profile
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">
                                    <div className="p-5" id="horizontal-form">
                                        <form className="preview" onSubmit={event => this.handleProfileSubmit(event)} method="post">
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">First Name</label>
                                                    <input type="text" name="fname" defaultValue={this.state.rdata.fname} className="input w-full border mt-2 flex-1" placeholder="Enter first name" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Last Name</label>
                                                    <input type="text" name="lname" defaultValue={this.state.rdata.lname} className="input w-full border mt-2 flex-1" placeholder="Enter last name" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Phone Number</label>
                                                    <input type="text" name="phone_no" defaultValue={this.state.rdata.phone_no} className="input w-full border mt-2 flex-1" placeholder="Enter phone number" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Gender</label>
                                                    <select name="gender" className="input w-full border mt-2 flex-1" >
                                                        <option value="">Select a gender</option>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                        <option value="others">Others</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Address</label>
                                                    <input type="text" name="address" defaultValue={this.state.rdata.address} className="input w-full border mt-2 flex-1" placeholder="Enter address" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center mt-5">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <button type="submit" className="button bg-theme-3 text-white w-1/4">Save</button>
                                                </div>
                                            </div>
                                        </form>
                                        { this.state.rstatus !== '' ?
                    
                                            <p className="ml-5" style={{ color: this.state.palertColor, paddingTop: "10px"}}>
                                                {this.state.rpmessage}
                                            </p>
                            
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="intro-y flex items-center mt-16">
                            <h2 className="text-lg font-medium mr-auto">
                                Settings
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">
                                    <div className="p-5" id="horizontal-form">
                                        <form className="preview" onSubmit={event => this.handleSettingsSubmit(event)} method="post">
                                            <div className="flex flex-col sm:flex-row items-center mt-3">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">New Password</label>
                                                    <input type="password" name="password" defaultValue="" className="input w-full border mt-2 flex-1" placeholder="Enter new password" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <button type="submit" className="button bg-theme-3 mt-6 flex-1 text-white w-1/4">Save</button>
                                                </div>
                                            </div>
                                        </form>
                                        { this.state.rstatus !== '' ?
                    
                                            <p className="ml-5" style={{ color: this.state.salertColor, paddingTop: "10px"}}>
                                                {this.state.rsmessage}
                                            </p>
                            
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalAccountSettings;
